import { Box, Typography } from "@mui/material";
import { CPSummaryV3Type } from "DataTypes/Services/Careplan.type";
import { FC, Fragment } from "react";
import RenderAns from "./RenderAns";
import ColorData1 from "CstmTheme/ColorData";
import {
  CPPAPType,
  PreApprovedOptionType,
} from "DataTypes/PatientManagement.type";

const SummaryView: FC<{
  summary: CPSummaryV3Type[],
  papSummary?: CPPAPType[]
}> = ({ summary, papSummary }) => {
  const optionUI: (
    optArr: PreApprovedOptionType[],
    parentId: number | null
  ) => React.ReactElement = (optArr, parentId) => {
    return (
      <Fragment>
        {optArr.filter(filEl => filEl.parentId == parentId).map(optEl => {
          return (
            <Fragment key={optEl.id}>
              <li>
                <Typography variant="subtitle1">
                  {optEl.label}
                </Typography>
              </li>
              <ul>
                {optionUI(optArr, optEl.id)}
              </ul>
            </Fragment>
          )
        })}
      </Fragment>
    )
  };

  const PreApprovedView = (
    papSummary?.map(papEl => {
      return (
        <Box
          border="1px solid"
          borderColor="custom.main"
          borderRadius={1.25}
          mb={2}
          key={papEl.problemId}
        >
          <Box sx={{ backgroundColor: "secondary.main" }} py={1}>
            {papEl.icdCodes.map((icdEl, index) => {
              return (
                <Typography
                  key={icdEl.icdCode}
                  variant="subtitle1"
                  ml={1}
                  {...(index != papEl.icdCodes.length - 1 && { mb: 1 })}
                  color="white"
                >
                  {icdEl.description
                    ? `${icdEl.description} `
                    : ""}
                  {icdEl.icdCode ? `(${icdEl.icdCode})` : ""}
                </Typography>
              );
            })}
          </Box>
          {papEl.category.map(catEl => {
            return (
              <Box
                sx={{ backgroundColor: "bg.main" }}
                key={catEl.categoryId}
              >
                <Typography variant="body2" p={1}>
                  {catEl.categoryType}:
                </Typography>
                <Box
                  sx={{
                    p: 1,
                    backgroundColor: "white",
                    color: ColorData1.primary.main,
                    "& ul": { pl: 2.5, my: 0 },
                    "& ol": { pl: 2.5, my: 0 },
                    "& li": { mb: 1 },
                  }}
                >
                  <ul>
                    {optionUI(catEl.options, null)}
                  </ul>
                </Box>
              </Box>
            )
          })}
        </Box>
      )
    })
  );

  return (
    <Fragment>
      {PreApprovedView}
      {summary.map((el) => {
        return (
          <Box
            key={el.id}
            border="1px solid"
            borderColor="custom.main"
            borderRadius={1.25}
            mb={2}
          >
            <Box sx={{ backgroundColor: "secondary.main" }} py={1}>
              {el.icdCodeList.map((icdEl, index) => {
                return (
                  <Typography
                    key={icdEl.id}
                    variant="subtitle1"
                    ml={1}
                    {...(index != el.icdCodeList.length - 1 && { mb: 1 })}
                    color="white"
                  >
                    {icdEl.icdCodeDescription
                      ? `${icdEl.icdCodeDescription} `
                      : ""}
                    {icdEl.icdCodeName ? `(${icdEl.icdCodeName})` : ""}
                  </Typography>
                );
              })}
            </Box>
            {el.summary.goals.length > 0 && (
              <Box sx={{ backgroundColor: "bg.main" }}>
                <Typography variant="body2" p={1}>
                  Goals:
                </Typography>
                <Box sx={{ backgroundColor: "white" }} p={1}>
                  {el.summary.goals.map((quesEl) => (
                    <RenderAns key={quesEl.id} data={quesEl} />
                  ))}
                </Box>
              </Box>
            )}
            {el.summary.interventions.length > 0 && (
              <Box sx={{ backgroundColor: "bg.main" }}>
                <Typography variant="body2" p={1}>
                  Interventions:
                </Typography>
                <Box sx={{ backgroundColor: "white" }} p={1}>
                  {el.summary.interventions.map((quesEl) => (
                    <RenderAns key={quesEl.id} data={quesEl} />
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        );
      })}
    </Fragment>
  );
};

export default SummaryView;
